import type {BusinessInfoData} from './BusinessInfoData';

export type BusinessInfoRequestBody = {
  businessInfoData: BusinessInfoData;
  businessAddressId: string | null;
};
